import { isPasswordValid, PASSWORD_VALIDATION_MESSAGE, areFieldsPristine, areAnyFieldsPristine } from "../FieldValidators";

/**
 * Validates the user inputs of the password reset code form
 *
 * @param {object} fields
 */
export const validateChangePasswordForm = fields => {
  const fieldErrors = {};
  const hasChanged = !areFieldsPristine(fields);
  if (!hasChanged) {
    return {
      fieldErrors,
      isFormInvalid: true
    };
  }
  const {
    oldPassword,
    newPassword,
    confirmPassword
  } = fields;
  if (!oldPassword.pristine && !isPasswordValid(oldPassword.value)) {
    fieldErrors.oldPassword = PASSWORD_VALIDATION_MESSAGE;
  }
  if (!newPassword.pristine && !isPasswordValid(newPassword.value)) {
    fieldErrors.newPassword = PASSWORD_VALIDATION_MESSAGE;
  }
  if (!oldPassword.pristine && !newPassword.pristine && oldPassword.value === newPassword.value) {
    fieldErrors.newPassword = "New password should not be the same as your old password";
  }
  if (!confirmPassword.pristine && !newPassword.pristine && confirmPassword.value !== newPassword.value) {
    fieldErrors.confirmPassword = "New and confirmed password should be the same";
  }
  const isFormInvalid = Object.keys(fieldErrors).length > 0 || areAnyFieldsPristine(fields);
  return {
    fieldErrors,
    isFormInvalid
  };
};